import { defineComponent, ref, computed, onMounted } from '@vue/composition-api';
import { fitIntoSimilarLengthLines } from './textSize.js';

var script = defineComponent({
    name: 'PrettyLineSplit',
    props: {
        text: {
            type: String,
            required: true,
        },
        title: {
            type: String,
            required: false,
            default: '',
        },
    },
    setup: function (props) {
        var elementRef = ref();
        var containerWidth = ref();
        var containerHorizontalPadding = ref();
        var fontSize = ref();
        var fontWeight = ref();
        var prettyText = computed(function () {
            if (!containerWidth.value
                || containerHorizontalPadding.value === undefined
                || !fontSize.value
                || !fontWeight.value) {
                return '';
            }
            return fitIntoSimilarLengthLines(props.text, Math.floor(containerWidth.value - containerHorizontalPadding.value), {
                fontWeight: fontWeight.value,
                fontSize: fontSize.value,
            });
        });
        onMounted(function () {
            var el = elementRef.value;
            var style = window.getComputedStyle(el, null);
            fontSize.value = style.getPropertyValue('font-size');
            fontWeight.value = style.getPropertyValue('font-weight');
            containerWidth.value = el.getBoundingClientRect().width;
            containerHorizontalPadding.value = parseFloat(style.getPropertyValue('padding-left'))
                + parseFloat(style.getPropertyValue('padding-right'));
        });
        return {
            elementRef: elementRef,
            prettyText: prettyText,
        };
    },
});

export default script;
